import { useAppConfig } from 'src/modules/appConfig';

import type { CreateResumeRoute } from './types';

export const createResumeRoutes: CreateResumeRoute[] = [
  'personal-details',
  'career-history',
  'education',
  'licences',
  'skills',
  'languages',
  'summary',
  'finish-resume',
];

export const useGetCreateResumeRoutes = () => {
  const { showFeature } = useAppConfig();
  const showPersonalSummary = showFeature('personal-summary');

  if (!showPersonalSummary) {
    return createResumeRoutes.filter((route) => route !== 'summary');
  }

  return createResumeRoutes;
};
